export default __webpack_public_path__ + "static/media/310.065b3db0.png";